import { apiPost, extractMessage } from "./client.js";

const TWOFA_STATUS = "/api/method/dynesourcerapi.author.twofa_status";
const TWOFA_BEGIN_SETUP = "/api/method/dynesourcerapi.author.twofa_begin_setup";
const TWOFA_CONFIRM_SETUP = "/api/method/dynesourcerapi.author.twofa_confirm_setup";
const TWOFA_DISABLE = "/api/method/dynesourcerapi.author.twofa_disable";
const LOGIN_VERIFY_OTP = "/api/method/dynesourcerapi.author.login_verify_otp";

function peel(data) {
  const msg = extractMessage(data);
  if (msg && typeof msg === "object" && !Array.isArray(msg)) return msg;
  if (data && typeof data === "object") return data;
  return {};
}

export function loginRequiresTwoFactor(data) {
  const m = peel(data);
  return Boolean(m.two_factor_required);
}

export function getLoginTwoFactorContext(data) {
  const m = peel(data);
  return {
    tmpId: String(m.tmp_id || "").trim(),
    email: String(m.user || "").trim().toLowerCase(),
    method: String(m.method || "email").trim(),
    ttlSec: Number(m.ttl_sec) || 300,
  };
}

export async function verifyLoginOtp({ tmp_id, otp }) {
  const res = await apiPost(LOGIN_VERIFY_OTP, {
    tmp_id,
    otp: String(otp || "").trim(),
  });
  return peel(res);
}

export async function fetchTwoFaStatus() {
  const res = await apiPost(TWOFA_STATUS, {});
  const m = peel(res);
  return {
    ok: Boolean(m.ok),
    user: String(m.user || "").trim(),
    enabled: Boolean(Number(m.twofa_enabled)),
    mode: String(m.twofa_mode || "email"),
    totpConfigured: Boolean(Number(m.totp_configured)),
  };
}

export async function beginTwoFaSetup(method = "email") {
  const res = await apiPost(TWOFA_BEGIN_SETUP, { method });
  const m = peel(res);
  return {
    ok: Boolean(m.ok),
    method: String(m.method || method),
    user: String(m.user || "").trim(),
    tmpId: String(m.tmp_id || "").trim(),
    ttlSec: Number(m.ttl_sec) || 300,
    message: String(m.message || ""),
  };
}

export async function disableTwoFa({ tmp_id, otp, method = "email" }) {
  const res = await apiPost(TWOFA_DISABLE, {
    tmp_id,
    otp: String(otp || "").trim(),
    method: String(method || "email"),
  });
  const m = peel(res);
  return {
    ok: Boolean(m.ok),
    enabled: Boolean(m.enabled),
    mode: String(m.mode || ""),
  };
}

export async function confirmTwoFaSetup({ tmp_id, otp, method = "email" }) {
  const res = await apiPost(TWOFA_CONFIRM_SETUP, {
    tmp_id,
    otp: String(otp || "").trim(),
    method: String(method || "email"),
    mode: "email",
    enabled: 1,
  });
  const m = peel(res);
  return {
    ok: Boolean(m.ok),
    enabled: Boolean(m.enabled),
    mode: String(m.mode || "email"),
  };
}
